interface AchievementBadgesProps {
  achievements: string[];
}

/** Renders earned achievement badges (e.g. "First 50 Points") on the student progress dashboard (US5). */
function AchievementBadges({ achievements }: AchievementBadgesProps) {
  if (achievements.length === 0) {
    return <p>Aucun badge obtenu pour le moment.</p>;
  }

  return (
    <ul
      aria-label="Badges obtenus"
      style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', listStyle: 'none', padding: 0 }}
    >
      {achievements.map((achievement) => (
        <li
          key={achievement}
          style={{
            border: '1px solid var(--color-border-strong)',
            borderRadius: '999px',
            padding: '0.25rem 0.75rem',
            background: 'var(--color-bg-elevated)',
          }}
        >
          🏅 {achievement}
        </li>
      ))}
    </ul>
  );
}

export default AchievementBadges;
